<template lang="pug">
.d-index
  .top-swiper
      .swiper-container
        .swiper-wrapper
            .swiper-slide
              img(src="~assets/index/swiper1.png")
            .swiper-slide
              img(src="~assets/index/swiper2.png")
            .swiper-slide
              img(src="~assets/index/swiper3.png")
            .swiper-slide
              img(src="~assets/index/swiper4.png")

      img.logo(src="~assets/index/img1.png")
  .brand-desc
    .line1 懂窝相信，家的样子，不应被任何风格所具象定义。
    .line3 我们甄选有人性温度的好设计，以不过度张扬的生活审美、长久陪伴的细腻品质，<br/>为你的家一点一点增添动人温情，打造属于自己的理想生活。
    //- .line3 希望眼光独到的你，在实现理想家居生活的路上，拥有更加笃定的选择。
  .module1
    .title 真正贴近用户的甄选
      .border
    .line1 我们的每一件产品都经过专业选品团队反复对比甄选，力求设计、品质、性价比、功能和舒适度等维度的平衡。<br/>
    .line1 与此同时，基于对欧美市场的调研及对国内消费者的家居审美与使用偏好的观察，我们综合权衡每个品类、每件产品<br/>的款式、风格与价格，力求将最优的选择呈现给对家居审美有追求的客户，让大家挑选过程更加从容。
  .module2
    .item
      img.left(src="~assets/index/img4.png")
      .right
        .title 品位设计，生活之审美
        .desc 我们放眼全球搜罗精良产品，不盲目追随前卫和潮流，但也拒绝平庸审美，希望能用恰到好处的设计感，满足真实生活的需求与审美。
    .item
      img.left(src="~assets/index/img5.png")
      .right
        .title 严控工艺，兼具品质与舒适
        .desc 高品质与舒适度是我们选品的重要标准。懂窝所合作的国内外一线工厂，拥有稳定精良的质量把控体系。
        .desc 每一件产品在出厂前，都经过材质、工艺、体验等方面反复检验与测试，懂窝选品团队更是对实物进行逐一体验，确保坐感或触感等各方面具备令人满意的舒适度。
    .item
      img.left(src="~assets/index/img6.png")
      .right
        .title 源头直采，物超所值
        .desc 在确保品质与舒适的同时，我们尽量控制成本，追求性价比。
        .desc 专业买手深入供应链上游直采，从工厂直接到消费者，省去了品牌商、代理商、经销商等层层溢价，同时采用无库存敏捷供应链，优化运营效率与缩减成本，充分让客户感到物超所值。
    .item
      img.left(src="~assets/index/img7.png")
      .right
        .title 多元风格，可混搭融合
        .desc 我们的产品涵盖：<br/>复古轻奢、粗犷工业、质朴原木、 现代北欧、当代摩登等多种风格。<br/>满足更多追求家居审美人群的喜好与需求。同时力求产品之间可以相互混搭，即便风格各异也毫不突兀。
  .module3
    .title 有人性温度的好设计
      .border
    .line1 懂窝通过探索现代人居家生活，<br/>结合性格型态学，糅炼出<br/>「＋骛美」、「－物然」、「×质想」、「÷颜趣」四个产品系列。
  .module4
    .item
      img.left(src="~assets/index/img27.png")
      .right
        .title
          .icon ➕
          .subTitle
            .line1 骛美
            .line2 Aesthetic
        .desc
          .line1 更追求设计感的领袖家
          .line2 渴望有序而规律<br/>充满设计感的家具<br/>带来更多安静与祥和
    .item
      img.left(src="~assets/index/img28.png")
      .right
        .title
          .icon ➖
          .subTitle
            .line1 物然
            .line2 Practicality
        .desc
          .line1 着重实用体验的生活家
          .line2 渴望随遇而安的笃定<br/>给家更多温暖与实用<br/>是你触手可及的幸福。
    .item
      img.left(src="~assets/index/img29.png")
      .right
        .title
          .icon ✖️
          .subTitle
            .line1 质想
            .line2 Quality
        .desc
          .line1 专享细腻品质的思考家
          .line2 喜欢独立思考<br/>坚持能深得你心的<br/>一定是经得起时间考验的
    .item
      img.left(src="~assets/index/img30.png")
      .right
        .title
          .icon ➗
          .subTitle
            .line1 颜趣
            .line2 Fun
        .desc
          .line1 敢尝有颜有趣的探索家
          .line2 好看皮囊和有趣的灵魂都想要<br/>只有新鲜材质与趣意设计<br/>才能彰显你的与众不同
  .module5
    .title 产品品质源于品质工厂
      .border
    .line1 懂窝所合作的家具家居工厂，均为国际一线家居品牌的源头制造商。<br/>工艺及环保标准符合欧美国家的进口标准。<br/>我们致力于将品质家具的优质体验，呈现给每一位懂窝的用户。
  .module6
    .item
      .text-box
        .line1 知名家具源头制造商
        .line2 30多年家具制造经验，HAY、Bo Concept、圣奥、顾家<br/>等众多国内外知名品牌源头制造商。
    .item
      .text-box
        .line1 实力家具外贸工厂
        .line2 产品95％用于海外市场，<br/> MADE.com、5 Horizon GroupPT Home <br/>Center、Castlery等国外知名电商及家具平台合作商。
    .item
      .text-box
        .line1 国内知名沙发制造商
        .line2 33年家具制造经验，产品远销法国、英国、俄罗斯、美<br/>国、加拿大等三十多个国家和地区。
  .module7
    .title 售卖产品 更是服务
      .border
    .line1 每一位懂窝客户都将获得贴心周到的服务，至您踏入懂窝门店或与我们客服联系的那刻起，您将获得——专业的售<br/>前咨询服务、软装搭配服务、免费送货安装服务和及时响应的售后服务，让您整个家具购买体验顺畅而安心。
  .module8
    .item
      img(src="~assets/index/iocn1.png")
      p 3年<br/>质量保障
    .item
      img(src="~assets/index/iocn2.png")
      p 免费<br/>送货上门
    .item
      img(src="~assets/index/iocn3.png")
      p 免费<br/>专业安装
    .item
      img(src="~assets/index/iocn4.png")
      p 提前预定<br/>免费仓储
    .item
      img(src="~assets/index/iocn5.png")
      p 7天<br/>无理由退换
    .item
      img(src="~assets/index/iocn6.png")
      p 开具<br/>正规发票
  .module9
    .title 不同渠道 相同体验
      .border
    .line1 我们致力于打造线上线下全品类场景化体验。<br/> 通过懂窝线下店，您可以亲临有温度的加减乘除空间，通过场景化沉浸式体验，实地触摸、挑选心仪的产品，<br/>同时收获更多灵感启发；门店未展示的商品可通过懂窝天猫店和懂窝微信小程序轻松在线浏览，<br/>让您更便捷地拥有心仪的家居好物。
  .module10
    .title 懂窝线下体验店
    .cont
      img(src="~assets/index/img14.png")
      img(src="~assets/index/img15.png")
    .address 懂窝上海世博店 | 望达路1号B3-C 103
    .cont
      img(src="~assets/index/img20.jpg")
      img(src="~assets/index/img21.png")
    .address 懂窝上海南丰城店 | 长宁区遵义路100号虹桥南丰城南区L218
    .cont
      img(src="~assets/index/img22.png")
      img(src="~assets/index/img23.png")
    .address 懂窝上海LaLaport店 | 浦东新区新金桥路738号LaLaport 405&406
    .cont
      img(src="~assets/index/img24.jpg")
      img(src="~assets/index/img25.png")
    .address 懂窝上海万象城店 | 闵行区吴中路1599号万象城L533
  .module11
    .title 懂窝电商渠道
    .cont
      .line1 一键购买心仪好物
      .line2 足不出户 体验便捷
      .code-box
        img(src="~assets/index/img17.png")
        p 扫码进入<br/> 懂窝天猫店
        img(src="~assets/index/img18.png")
        p 扫码进入<br/> 懂窝小程序
  .module12
    .title 品牌合作伙伴
    .border
    img(src="~assets/index/img19.jpg")
  img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")

</template>
<script>
export default {
  data() {
    return {
      scrollTop: false
    };
  },
  computed: {},
  created() {
    this.$bus.$on("scrollTopFn", el => {
      this.goTop(el);
    });
  },
  mounted() {
    this.$nextTick(() => {
      var mySwiper = new Swiper(".swiper-container", {
        paginationClickable: true,
        loop: true,
        speed: 2200,
        autoplay: 2200,
        autoplayDisableOnInteraction: false,
        effect: "fade",
        onInit: function(swiper) {
          // swiper加载完毕
        }
      });
      let scrollEl = this.$route.query.scrollEl;
      if (scrollEl) {
        this.goTop(scrollEl);
      }
    });
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    goTop(el) {
      let top = document.getElementsByClassName(el)[0].offsetTop;
      document.documentElement.scrollTop = top;
    },
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>
<style lang="sass">
@import 'config'
.d-index
  width: 100%
  .top-swiper
    width: 100%
    position: relative
    .swiper-container
      width: 100%
      .swiper-wrapper
        width: 100%
        .swiper-slide
          width: 100% !important
          img
            width: 100%
    .logo
      width: r(513)
      height: r(204)
      margin: auto
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      z-index: 10
  .brand-desc
    width: 100%
    text-align: center
    padding-top: r(140)
    .line1
      font-family: PingFangSC-Semibold
      font-size: r(30)
      color: #000000
    .line2
      margin-top: r(40)
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #000000
      line-height: r(42)
    .line3
      margin-top: r(40)
      margin-bottom: r(200)
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #000000
      line-height: r(42)
  .module1
    width: 100%
    height: r(855)
    padding-top: r(275)
    background: url('~assets/index/img3.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module2
    margin: 0 auto
    width: r(1320)
    padding-top: r(158)
    .item
      margin-bottom: r(194)
      width: 100%
      display: flex
      justify-content: space-between
      align-items: flex-end
      &:nth-child(2n)
        flex-flow: row-reverse
      .left
        width: r(710)
      .right
        width: r(488)
        .title
          width: 100%
          font-family: PingFangSC-Semibold
          font-size: r(30)
          color: #000000
        .desc
          margin-top: r(28)
          width: 100%
          font-family: PingFangSC-Regular
          font-size: r(20)
          color: #000000
          line-height: r(31)
  .module3
    width: 100%
    height: r(855)
    padding-top: r(275)
    background: url('~assets/index/img26.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module4
    margin: 0 auto
    width: r(1320)
    padding-top: r(158)
    .item
      margin-bottom: r(194)
      width: 100%
      display: flex
      justify-content: space-between
      align-items: flex-end
      &:nth-child(2n)
        flex-flow: row-reverse
      .left
        width: r(710)
      .right
        width: r(488)
        .title
          width: 100%
          font-family: PingFangSC-Semibold
          color: #000000
          display: flex
          .icon
            font-size: r(80)
          .subTitle
            .line1
              font-size: r(40)
            .line2
              font-size: r(30)
        .desc
          margin-top: r(20)
          width: 100%
          font-family: PingFangSC-Regular
          color: #000000
          .line1
            font-size: r(24)
            line-height: r(40)
          .line2
            margin-top: r(20)
            font-size: r(20)
            line-height: r(31)
  .module5
    width: 100%
    height: r(855)
    padding-top: r(275)
    background: url('~assets/index/img8.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module6
    margin: 0 auto
    padding-top: r(163)
    width: r(1322)
    .item
      margin-bottom: r(132)
      width: 100%
      height: r(382)
      background: url('~assets/index/img9.png') no-repeat center / cover
      padding-top: 0.1px
      text-align: right
      &:nth-child(2)
        background: url('~assets/index/img10.png') no-repeat center / cover
      &:nth-child(3)
        background: url('~assets/index/img11.png') no-repeat center / cover
      &:nth-child(2n)
        text-align: left
    .text-box
      margin: r(152) auto 0
      width: r(1192)
      display: flex
      flex-direction: column
      .line1
        font-family: PingFangSC-Semibold
        font-size: r(30)
        color: #FEFFFF
      .line2
        margin-top: r(23)
        font-family: PingFangSC-Medium
        font-size: r(20)
        color: #FEFFFF
        line-height: r(32)
  .module7
    width: 100%
    height: r(855)
    padding-top: r(275)
    background: url('~assets/index/img12.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module8
    margin: r(204) auto r(167)
    width: r(1300)
    display: flex
    justify-content: space-between
    .item
      width: r(174)
      height: r(241)
      background: url('~assets/index/iocn0.png') no-repeat center / 100%
      display: flex
      flex-direction: column
      align-items: center
      padding-top: r(30)
      img
        width: r(74)
      p
        margin-top: r(40)
        width: 100%
        text-align: center
        font-family: PingFangSC-Regular
        font-size: r(25)
  .module9
    width: 100%
    height: r(855)
    padding-top: r(275)
    background: url('~assets/index/img13.png') no-repeat center / cover
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #FEFFFF
      text-align: center
      .border
        margin: r(40) auto 0
        width: r(42)
        height: r(4)
        background: #ffffff
    .line1
      margin-top: r(54)
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(25)
      color: #FEFFFF
      text-align: center
      line-height: r(42)
  .module10
    margin: r(166) auto 0
    width: r(1324)
    .title
      width: 100%
      font-family: PingFangSC-Semibold
      font-size: r(40)
      color: #000000
      text-align: center
    .cont
      margin-top: r(82)
      width: 100%
      display: flex
      justify-content: space-between
      img
        width: r(636)
    .address
      margin-top: r(55)
      width: 100%
      font-family: PingFangSC-Semibold
      font-size: r(30)
      color: #000000
      text-align: center
  .module11
    margin: r(194) auto 0
    width: r(1324)
    .title
      width: 100%
      font-family: PingFangSC-Semibold
      font-size: r(40)
      color: #000000
      text-align: center
    .cont
      margin-top: r(76)
      width: 100%
      height: r(730)
      background: url('~assets/index/img16.png') no-repeat center / cover
      padding-top: 0.1px
      .line1
        margin: r(85) 0 0 r(122)
        font-family: PingFangSC-Semibold
        font-size: r(46)
        color: #FEFFFF
      .line2
        margin: r(15) 0 0 r(122)
        font-family: PingFangSC-Semibold
        font-size: r(26)
        color: #FEFFFF
      .code-box
        margin: r(318) 0 0 r(70)
        display: flex
        align-items: flex-end
        img
          width: r(147)
          // &:nth-child(3)
          //   width: r(128)
        p
          margin-left: r(24)
          margin-right: r(30)
          font-family: PingFangSC-Semibold
          font-size: r(22)
          color: #FEFFFF
  .module12
    margin: r(228) auto r(210)
    width: r(1298)
    .title
      width: 100%
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #000000
      text-align: center
    .border
      margin: r(40) auto 0
      width: r(42)
      height: r(4)
      background: #201813
    img
      margin-top: r(160)
      width: 100%
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// index.vue?279f5bab